import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreloadImageService {
  constructor(@Inject(PLATFORM_ID) private platformId: any) {
  }

  setPreloadLink(url: string): void {
    if (isPlatformBrowser(this.platformId)) {
      const link: HTMLLinkElement = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = url;
      link.setAttribute('fetchpriority', 'high');
      document.head.appendChild(link);
    }
  }
}
